import { createSelector } from 'reselect';
import { NAME } from './constants';

export const getModel = state => state[NAME];

/** activeElement **/
export const getActiveElementModel = createSelector(
    getModel,
    (model) => model.activeElement
);

/** activeElement **/
export const getActiveElement = createSelector(
    getActiveElementModel,
    (activeElement) => activeElement.data
);
export const getIsFetchingElement = createSelector(
    getActiveElementModel,
    (activeElement) => activeElement.isFetching
);
export const getSpeedTable = createSelector(
    getActiveElementModel,
    (activeElement) => activeElement.speedTable
);
export const getIsSavingSpeedTable = createSelector(
    getActiveElementModel,
    (activeElement) => activeElement.isSavingSpeedTable
);
export const getMakeReadyMarkups = createSelector(
    getActiveElementModel,
    (activeElement) => activeElement.makeReadyMarkups
);
export const getIsSavingMakeReadyMarkups = createSelector(
    getActiveElementModel,
    (activeElement) => activeElement.isSavingMakeReadyMarkups
);
export const getBhrMarkups = createSelector(
    getActiveElementModel,
    (activeElement) => activeElement.bhrMarkups
);
export const getIsSavingBhrMarkups = createSelector(
    getActiveElementModel,
    (activeElement) => activeElement.isSavingBhrMarkups
);
export const getActivePapers = createSelector(
    getActiveElementModel,
    (activeElement) => activeElement.activePapers
);
export const getIsSavingActivePapers = createSelector(
    getActiveElementModel,
    (activeElement) => activeElement.isSavingActivePapers
);

/** form **/
export const getForm = createSelector(
    getModel,
    (model) => model.form
);
export const getFormValues = createSelector(
    getForm,
    (form) => form.formValues
);
export const getIsSavingForm = createSelector(
    getForm,
    (form) => form.isSaving
);
export const getFormErrors = createSelector(
    getForm,
    (form) => form.formErrors
);
export const getFormErrorsMessages = createSelector(
    getForm,
    (form) => form.formErrorMessages
);

/** elements **/
export const getElements = createSelector(
    getModel,
    (model) => model.elements.data
);
export const getProcessedElements = createSelector(
    getModel,
    (model) => model.elements.processedElements
);
export const getIsFetchingElements = createSelector(
    getModel,
    (model) => model.elements.isFetching
);

/** delete **/
export const getIsDeleting = createSelector(
    getModel,
    (model) => model.delete.isDeleting
);
export const getIdForDelete = createSelector(
    getModel,
    (model) => model.delete.id
);

/** pagination **/
export const getTotalItems = createSelector(
    getModel,
    (model) => model.pagination.totalItems
);
export const getTotalPages = createSelector(
    getModel,
    (model) => model.pagination.totalPages
);
export const getSelectedPage = createSelector(
    getModel,
    (model) => model.pagination.selectedPage
);
export const getElementsPerPage = createSelector(
    getModel,
    (model) => model.pagination.elementsPerPage
);

/** sort **/
export const getSortColumn = createSelector(
    getModel,
    (model) => model.sort.column
);
export const getSortType = createSelector(
    getModel,
    (model) => model.sort.type
);

/** information **/
export const getIsFetchingInformation = createSelector(
    getModel,
    (model) => model.information.isFetching
);
export const getInformation = createSelector(
    getModel,
    (model) => model.information
);

/** options **/
export const getOptions = createSelector(
    getModel,
    (model) => model.options
);

/** fetching **/
export const getFetching = createSelector(
    getModel,
    (model) => model.fetching
);

/** filter **/
export const getFilterFields = createSelector(
    getModel,
    (model) => model.filter.fields
);
